import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, RowNode } from 'ag-grid-community';
import { round } from '../utilities/math-utilities';

@Component({
  selector: 'custom-group-cell-renderer',
  template: `
  <div class="row">
    <span class="groupTitle">{{ node.key }}</span>
    <span class="groupAgg"> - Qty Total: {{node.allChildrenCount}}</span>
    <span class="groupAgg"> - Cost Total: {{currencyFormatter(total,'$')}}</span>
  </div>
  `,
  styles: [
    `
      .row {
        margin: 0px;
        display: inline-block;
      }

      .groupTitle {
        font-weight: bold;
      }
      .groupAgg {
      }

    `
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class PxdAgGridCustomGroupCellRendererComponent implements ICellRendererAngularComp {

  public params!: ICellRendererParams;
  public node!: RowNode;
  public total: number;

  agInit(params: any): void {
    this.total = 0;
    this.params = params;
    this.node = params.node;
    if (this.node.allLeafChildren)
      this.node.allLeafChildren.forEach(x => this.total = this.total + x.data.ExtendedValue);
    this.total = round(this.total, 2);
  }

  refresh(): boolean {
    return false;
  }

  currencyFormatter(currency: number, sign: string): string {
    var sansDec = currency.toFixed(2);
    var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sign + `${formatted}`;
  }
}